<h2>Begründung der Ablehnung</h2>
<mat-dialog-content>
  <form [formGroup]="rejectForm" class="content">
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Kommentar (Optional)</mat-label>
      <input
        type="text"
        matInput
        formControlName="comment"
        [errorStateMatcher]="matcher">
      <mat-hint *ngIf="!validationService.latinLettersAndPunctuationValidator(rejectForm.controls.comment.value)">Text/Meldung wird ohne Sonderzeichen gespeichert</mat-hint>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="actions">
  <button mat-button mat-dialog-close color="warn" appearance="outline">Abbrechen</button>
  <button mat-raised-button color="accent" [disabled]="!rejectForm.valid" (click)="onConfirm()">Speichern</button>
</mat-dialog-actions>
